import { createSelector } from 'reselect';
import { keyBy, get, pipe, values } from 'lodash/fp';

const organisationsByCodeSelector = createSelector(
  get('organisations'),
  pipe(values, keyBy('code')),
);

export default organisationsByCodeSelector;
